import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["name", "required"]
const _hoisted_2 = ["value", "textContent", "selected"]

import { toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null,
    name: null,
    error: null,
    required: { type: Boolean },
    options: null,
    asValue: { default: 'value' },
    asLabel: { default: 'label' }
  },
  emits: ['update:modelValue', 'change'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue: unknown, name?: string, error?: string, required?: boolean, options?: object[], asValue: string, asLabel: string }




const {
  modelValue,
  name,
  error,
  required,
  options,
  asValue,
  asLabel,
} = toRefs(props);

const isSelected = (value: unknown) => modelValue.value === value;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("select", {
    class: _normalizeClass(["mt-1 relative shadow-sm block w-full border rounded-md sm:text-sm", _unref(error) ? 'border-red-300 focus:outline-red' : 'border-gray-300 placeholder-gray-400 focus:outline']),
    name: _unref(name),
    required: _unref(required),
    onInput: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', $event.target.value))),
    onChange: _cache[1] || (_cache[1] = ($event: any) => (emit('change', $event.target.value)))
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(options), (option) => {
      return (_openBlock(), _createElementBlock("option", {
        key: option[_unref(asValue)],
        value: option[_unref(asValue)],
        textContent: _toDisplayString(option[_unref(asLabel)]),
        selected: isSelected(option[_unref(asValue)])
      }, null, 8, _hoisted_2))
    }), 128))
  ], 42, _hoisted_1))
}
}

})